import React, {useState, useEffect} from 'react'
import Navbar from '../../Components/Navbar/Navbar'
// import toast from 'react-hot-toast';
import EditableScoreCard from '../../Components/EditableScoreCard'
import { 
    Layout,
    Col, 
    Row,
    Select,
    Button,
    Tabs,
    Space,
    Table,
    Typography
} from 'antd';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { 
  useNavigate,
  useParams,
 } from "react-router-dom"
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
// import { refreshPage } from '../../Utils/Common';

const { TabPane } = Tabs;
const { Option } = Select;
const { Title } = Typography;

const InvitationalScoreCard = () => {
  const { id, member_id } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [playerData, setPlayerData] = useState([])
  const [dayOneData, setDayOneData] = useState([])
  const [dayTwoData, setDayTwoData] = useState([])
  const [playerDivision, setPlayerDivision] = useState('');
  const [playerId, setPlayerId] = useState(member_id || '')
  // const [pageSize, setPageSize] = useState('');

  const [filterConfig, setFilterConfig] = useState({
    directors_cup_player: '',
    page: 1,
    tournament_id: id,
  })
  const { callPost, data } = usePostRequest(()=>{
    // refreshPage()
  });
  const dataHeader = [
    {
      key: '1',
      name: 'HOLES',
      score_1: 1,
      score_2: 2,
      score_3: 3,
      score_4: 4,
      score_5: 5,
      score_6: 6,
      score_7: 7,
      score_8: 8,
      score_9: 9,
      out: 'OUT',
      score_10: 10,
      score_11: 11,
      score_12: 12,
      score_13: 13,
      score_14: 14,
      score_15: 15,
      score_16: 16,
      score_17: 17,
      score_18: 18,
      in: 'IN',
      gross: 'GROSS',
      hdc: "HDC",
      points_total: "NET",
      isClickable: true,
    },
    {
      key: '2',
      name: 'PAR',
      score_1: 4,
      score_2: 3,
      score_3: 4,
      score_4: 4,
      score_5: 4,
      score_6: 3,
      score_7: 5,
      score_8: 3,
      score_9: 5,
      out: '35',
      score_10: 5,
      score_11: 4,
      score_12: 4,
      score_13: 3,
      score_14: 4,
      score_15: 3,
      score_16: 5,
      score_17: 4,
      score_18: 5,
      in: '37',
      gross: '72',
      hdc: '',
      isClickable: true,
    },
    {
      key: '3',
      name: 'HANDICAP (WHITE/RED)',
      score_1: 6,
      score_2: 18,
      score_3: 12,
      score_4: 8,
      score_5: 4,
      score_6: 16,
      score_7: 10,
      score_8: 4,
      score_9: 2,
      out: '',
      score_10: 1,
      score_11: 5,
      score_12: 9,
      score_13: 17,
      score_14: 11,
      score_15: 7,
      score_16: 3,
      score_17: 15,
      score_18: 13,
      in: '',
      hdc: "",
      isClickable: true,
    },
    // { 
    //   key: 'custom-row',
    // }
  ];

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("invitational_players/get_player", filterConfig);
    if (response?.data) {
      setPlayerData(response?.data?.data);
      if(member_id){
        return response?.data?.data
      }
      // setPageSize(response?.data?.size)
    } else {
      setPlayerData([])
      if(member_id){
        return []
      }
    }

    setIsLoading(false);
  }

  const handleAddOk = () => {
    const filter_one = dayOneData.filter(item => item.player_id);
    const filter_two = dayTwoData.filter(item => item.player_id)
    const data = {
      team_name: playerDivision?.team_name,
      player_id: filter_one[0].player_id,
      day1_gs_1: filter_one[0].score_1,
      day1_gs_2: filter_one[0].score_2,
      day1_gs_3: filter_one[0].score_3,
      day1_gs_4: filter_one[0].score_4,
      day1_gs_5: filter_one[0].score_5,
      day1_gs_6: filter_one[0].score_6,
      day1_gs_7: filter_one[0].score_7,
      day1_gs_8: filter_one[0].score_8,
      day1_gs_9: filter_one[0].score_9,
      day1_gs_10: filter_one[0].score_10,
      day1_gs_11: filter_one[0].score_11,
      day1_gs_12: filter_one[0].score_12,
      day1_gs_13: filter_one[0].score_13,
      day1_gs_14: filter_one[0].score_14,
      day1_gs_15: filter_one[0].score_15,
      day1_gs_16: filter_one[0].score_16,
      day1_gs_17: filter_one[0].score_17,
      day1_gs_18: filter_one[0].score_18,
      day2_gs_1: filter_two[0].score_1,
      day2_gs_2: filter_two[0].score_2,
      day2_gs_3: filter_two[0].score_3,
      day2_gs_4: filter_two[0].score_4,
      day2_gs_5: filter_two[0].score_5,
      day2_gs_6: filter_two[0].score_6,
      day2_gs_7: filter_two[0].score_7,
      day2_gs_8: filter_two[0].score_8,
      day2_gs_9: filter_two[0].score_9,
      day2_gs_10: filter_two[0].score_10,
      day2_gs_11: filter_two[0].score_11,
      day2_gs_12: filter_two[0].score_12,
      day2_gs_13: filter_two[0].score_13,
      day2_gs_14: filter_two[0].score_14,
      day2_gs_15: filter_two[0].score_15,
      day2_gs_16: filter_two[0].score_16,
      day2_gs_17: filter_two[0].score_17,
      day2_gs_18: filter_two[0].score_18,
    };
    var finalValues = Object.entries(data).map(([key, value]) => ({
        key,
        value,
    }));
    callPost(
        "invitational_scores/create", 
        finalValues,
        true
    );
  };

  async function fetchTeamData(id) {
    setIsLoading(true);
    setDayOneData([]);
    setDayTwoData([])
    const response = await UseGetRequest("invitational_scores/get", { invitational_player_id: id, tournament_id: filterConfig.tournament_id });
    if (response?.data) {
      const player_score_one = response?.data?.data?.map((data, index) => ({
        gross_scores:{ 
          name: 'GROSS SCORES',
          key: 3,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_gs_1,
          score_2: data.day1_gs_2,
          score_3: data.day1_gs_3,
          score_4: data.day1_gs_4,
          score_5: data.day1_gs_5,
          score_6: data.day1_gs_6,
          score_7: data.day1_gs_7,
          score_8: data.day1_gs_8,
          score_9: data.day1_gs_9,
          score_10: data.day1_gs_10,
          score_11: data.day1_gs_11,
          score_12: data.day1_gs_12,
          score_13: data.day1_gs_13,
          score_14: data.day1_gs_14,
          score_15: data.day1_gs_15,
          score_16: data.day1_gs_16,
          score_17: data.day1_gs_17,
          score_18: data.day1_gs_18,
          gross: data.day1_gross,
          hdc: data.hdc,
          in: data.day1_gs_in,
          out: data.day1_gs_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        gross_points:{ 
          name: 'GROSS POINTS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_gp_1,
          score_2: data.day1_gp_2,
          score_3: data.day1_gp_3,
          score_4: data.day1_gp_4,
          score_5: data.day1_gp_5,
          score_6: data.day1_gp_6,
          score_7: data.day1_gp_7,
          score_8: data.day1_gp_8,
          score_9: data.day1_gp_9,
          score_10: data.day1_gp_10,
          score_11: data.day1_gp_11,
          score_12: data.day1_gp_12,
          score_13: data.day1_gp_13,
          score_14: data.day1_gp_14,
          score_15: data.day1_gp_15,
          score_16: data.day1_gp_16,
          score_17: data.day1_gp_17,
          score_18: data.day1_gp_18,
          gross: data.day1_gross_points,
          hdc: data.hdc,
          in: data.day1_gp_in,
          out: data.day1_gp_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        net_scores:{ 
          name: 'NET SCORES',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_ns_1,
          score_2: data.day1_ns_2,
          score_3: data.day1_ns_3,
          score_4: data.day1_ns_4,
          score_5: data.day1_ns_5,
          score_6: data.day1_ns_6,
          score_7: data.day1_ns_7,
          score_8: data.day1_ns_8,
          score_9: data.day1_ns_9,
          score_10: data.day1_ns_10,
          score_11: data.day1_ns_11,
          score_12: data.day1_ns_12,
          score_13: data.day1_ns_13,
          score_14: data.day1_ns_14,
          score_15: data.day1_ns_15,
          score_16: data.day1_ns_16,
          score_17: data.day1_ns_17,
          score_18: data.day1_ns_18,
          net: data.day1_net,
          points_total: data.day1_net,
          hdc: '',
          in: data.day1_ns_in,
          out: data.day1_ns_out,
          isClickable: true,
        },
        net_points:{ 
          name: 'NET POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_np_1,
          score_2: data.day1_np_2,
          score_3: data.day1_np_3,
          score_4: data.day1_np_4,
          score_5: data.day1_np_5,
          score_6: data.day1_np_6,
          score_7: data.day1_np_7,
          score_8: data.day1_np_8,
          score_9: data.day1_np_9,
          score_10: data.day1_np_10,
          score_11: data.day1_np_11,
          score_12: data.day1_np_12,
          score_13: data.day1_np_13,
          score_14: data.day1_np_14,
          score_15: data.day1_np_15,
          score_16: data.day1_np_16,
          score_17: data.day1_np_17,
          score_18: data.day1_np_18,
          points: data.day1_net_points,
          points_total: data.day1_net_points,
          hdc: '',
          in: data.day1_np_in,
          out: data.day1_np_out,
          isClickable: true,
        }
      }))
      const player_score_two = response?.data?.data?.map((data, index) => ({
        gross_scores:{ 
          name: 'GROSS SCORES',
          key: 3,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_gs_1,
          score_2: data.day2_gs_2,
          score_3: data.day2_gs_3,
          score_4: data.day2_gs_4,
          score_5: data.day2_gs_5,
          score_6: data.day2_gs_6,
          score_7: data.day2_gs_7,
          score_8: data.day2_gs_8,
          score_9: data.day2_gs_9,
          score_10: data.day2_gs_10,
          score_11: data.day2_gs_11,
          score_12: data.day2_gs_12,
          score_13: data.day2_gs_13,
          score_14: data.day2_gs_14,
          score_15: data.day2_gs_15,
          score_16: data.day2_gs_16,
          score_17: data.day2_gs_17,
          score_18: data.day2_gs_18,
          gross: data.day2_gross,
          hdc: data.hdc,
          in: data.day2_gs_in,
          out: data.day2_gs_out,
          day2_adj_hdc: data.day2_adj_hdc,
        },
        gross_points:{ 
          name: 'GROSS POINTS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_gp_1,
          score_2: data.day2_gp_2,
          score_3: data.day2_gp_3,
          score_4: data.day2_gp_4,
          score_5: data.day2_gp_5,
          score_6: data.day2_gp_6,
          score_7: data.day2_gp_7,
          score_8: data.day2_gp_8,
          score_9: data.day2_gp_9,
          score_10: data.day2_gp_10,
          score_11: data.day2_gp_11,
          score_12: data.day2_gp_12,
          score_13: data.day2_gp_13,
          score_14: data.day2_gp_14,
          score_15: data.day2_gp_15,
          score_16: data.day2_gp_16,
          score_17: data.day2_gp_17,
          score_18: data.day2_gp_18,
          gross: data.day2_gross_points,
          hdc: data.hdc,
          in: data.day2_gp_in,
          out: data.day2_gp_out,
          day2_adj_hdc: data.day2_adj_hdc,
        },
        net_scores:{ 
          name: 'NET SCORES',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_ns_1,
          score_2: data.day2_ns_2,
          score_3: data.day2_ns_3,
          score_4: data.day2_ns_4,
          score_5: data.day2_ns_5,
          score_6: data.day2_ns_6,
          score_7: data.day2_ns_7,
          score_8: data.day2_ns_8,
          score_9: data.day2_ns_9,
          score_10: data.day2_ns_10,
          score_11: data.day2_ns_11,
          score_12: data.day2_ns_12,
          score_13: data.day2_ns_13,
          score_14: data.day2_ns_14,
          score_15: data.day2_ns_15,
          score_16: data.day2_ns_16,
          score_17: data.day2_ns_17,
          score_18: data.day2_ns_18,
          net: data.day2_net,
          points_total: data.day2_net,
          hdc: '',
          in: data.day2_ns_in,
          out: data.day2_ns_out,
          isClickable: true,
        },
        net_points:{ 
          name: 'NET POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_np_1,
          score_2: data.day2_np_2,
          score_3: data.day2_np_3,
          score_4: data.day2_np_4,
          score_5: data.day2_np_5,
          score_6: data.day2_np_6,
          score_7: data.day2_np_7,
          score_8: data.day2_np_8,
          score_9: data.day2_np_9,
          score_10: data.day2_np_10,
          score_11: data.day2_np_11,
          score_12: data.day2_np_12,
          score_13: data.day2_np_13,
          score_14: data.day2_np_14,
          score_15: data.day2_np_15,
          score_16: data.day2_np_16,
          score_17: data.day2_np_17,
          score_18: data.day2_np_18,
          points: data.day2_net_points,
          points_total: data.day2_net_points,
          hdc: '',
          in: data.day2_np_in,
          out: data.day2_np_out,
          isClickable: true,
        }
      }))
      const dayOneGs = player_score_one.map((player) => player.gross_scores);    
      const dayOneGp = player_score_one.map((player) => player.gross_points);    
      const dayOneNs = player_score_one.map((player) => player.net_scores);    
      const dayOneNp = player_score_one.map((player) => player.net_points);    

      const dayTwoGs = player_score_two.map((player) => player.gross_scores);    
      const dayTwoGp = player_score_two.map((player) => player.gross_points);    
      const dayTwoNs = player_score_two.map((player) => player.net_scores);    
      const dayTwoNp = player_score_two.map((player) => player.net_points);      

      setDayOneData(() => [
        ...dataHeader,
        ...dayOneGs,
        ...dayOneGp,
        ...dayOneNs,
        ...dayOneNp,
      ]);

      setDayTwoData(() => [
        ...dataHeader,
        ...dayTwoGs,
        ...dayTwoGp,
        ...dayTwoNs,
        ...dayTwoNp,
      ]);
    } else {
      const response2 = await UseGetRequest("invitational_players/get_player", { invitational_player_id: id });
      if(response2.data) {
        const day = {}
        for (let i=0; i<18; i++) {
          day[`score_${i+1}`] = ''
        }
        const day_one_player = response2?.data?.data?.map((data, index) => ({
          day1: {
            hdc: data.hdc,
            player_id: data.player_id,
            name: "GROSS",
            key: index + 1,
            ...day,
          }
        }))
        const day_two_player = response2?.data?.data?.map((data, index) => ({
          day2: {
            hdc: data.hdc,
            player_id: data.player_id,
            name: "GROSS",
            key: index + 1,
            ...day,
          }
        }))
        const dayOne = day_one_player.map((player) => player.day1);
        const dayTwo = day_two_player.map((player) => player.day2);

        setDayOneData(() => [
          ...dataHeader,
          ...dayOne,
        ]);

        setDayTwoData(() => [
          ...dataHeader,
          ...dayTwo,
        ]);

      } else {
        setDayOneData([]);
        setDayTwoData([]);
      }
    }
    setIsLoading(false);
  };

  const headerColumns = [
    {
      title: ' ',
      dataIndex: 'team_name',
      key: 'team_name',
      align: 'center',
      width: '25vw',
      onCell: () => ({
        editable: false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'name',
      key: 'name',
    }
  ];

  const columns = [
    {
      title: ' ',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      // width: '25vw',
      onCell: () => ({
        editable: false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_1',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_2',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_3',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_4',
      key: 'score_4',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_5',
      key: 'score_5',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_6',
      key: 'score_6',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_7',
      key: 'score_7',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_8',
      key: 'score_8',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_9',
      key: 'score_9',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'out',
      key: 'out',
      // onCell: (record) => ({
      //   editable: !record.isClickable ? true : false
      // })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_10',
      key: 'score_10',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_11',
      key: 'score_11',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_12',
      key: 'score_12',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_13',
      key: 'score_13',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_14',
      key: 'score_14',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_15',
      key: 'score_15',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_16',
      key: 'score_16',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_17',
      key: 'score_17',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_18',
      key: 'score_18',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'in',
      key: 'in',
      // onCell: (record) => ({
      //   editable: !record.isClickable ? true : false
      // })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'gross',
      key: 'gross',
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'hdc',
      key: 'hdc',
    },
  
    {
      title: '',
      align: 'center',
      dataIndex: 'points_total', 
      key: 'points_total',
    },
  
  ];

  const onChange = (activeKey) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        status:  activeKey
      }
    ));
  };

  const handlePlayerScore = (player_id, player_data) => {
    const data = player_data && player_data?.filter(item => item.player_id === player_id);
    setPlayerDivision(data[0])
    setPlayerId(player_id)
    fetchTeamData(player_id) 
  }

  const CustomRow = ({ children, record, ...props }) => { 
    if (props['data-row-key'] === 'custom-row') {  
      return (
        <tr {...props}>
          <td colSpan={1} className='custom-name'>
            <div className='center'>
              { playerDivision }
            </div>
          </td>
          <td colSpan={22} className='custom-data'>
            <div className='center'>
              GROSS
            </div>
          </td>
        </tr>
      );
    }
    return <tr {...props}>{children}</tr>;
  };

  const components = {
    body: {
      row: (props) => <CustomRow {...props} />,
    },
  };
  
  useEffect(() => {
    const fetchAndInit = async () => {
      const data = await fetchPlayerData(); 
  
      if (member_id && data) {
        handlePlayerScore(member_id, data);
      }
    };
  
    fetchAndInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member_id]);
  
  

  useEffect(() => {
    if(data){
      const player_score_one = data?.data?.map((data, index) => ({
        gross_scores:{ 
          name: 'GROSS SCORES',
          key: 3,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_gs_1,
          score_2: data.day1_gs_2,
          score_3: data.day1_gs_3,
          score_4: data.day1_gs_4,
          score_5: data.day1_gs_5,
          score_6: data.day1_gs_6,
          score_7: data.day1_gs_7,
          score_8: data.day1_gs_8,
          score_9: data.day1_gs_9,
          score_10: data.day1_gs_10,
          score_11: data.day1_gs_11,
          score_12: data.day1_gs_12,
          score_13: data.day1_gs_13,
          score_14: data.day1_gs_14,
          score_15: data.day1_gs_15,
          score_16: data.day1_gs_16,
          score_17: data.day1_gs_17,
          score_18: data.day1_gs_18,
          gross: data.day1_gross,
          hdc: data.hdc,
          in: data.day1_gs_in,
          out: data.day1_gs_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        gross_points:{ 
          name: 'GROSS POINTS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_gp_1,
          score_2: data.day1_gp_2,
          score_3: data.day1_gp_3,
          score_4: data.day1_gp_4,
          score_5: data.day1_gp_5,
          score_6: data.day1_gp_6,
          score_7: data.day1_gp_7,
          score_8: data.day1_gp_8,
          score_9: data.day1_gp_9,
          score_10: data.day1_gp_10,
          score_11: data.day1_gp_11,
          score_12: data.day1_gp_12,
          score_13: data.day1_gp_13,
          score_14: data.day1_gp_14,
          score_15: data.day1_gp_15,
          score_16: data.day1_gp_16,
          score_17: data.day1_gp_17,
          score_18: data.day1_gp_18,
          gross: data.day1_gross_points,
          hdc: data.hdc,
          in: data.day1_gp_in,
          out: data.day1_gp_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        net_scores:{ 
          name: 'NET SCORES',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_ns_1,
          score_2: data.day1_ns_2,
          score_3: data.day1_ns_3,
          score_4: data.day1_ns_4,
          score_5: data.day1_ns_5,
          score_6: data.day1_ns_6,
          score_7: data.day1_ns_7,
          score_8: data.day1_ns_8,
          score_9: data.day1_ns_9,
          score_10: data.day1_ns_10,
          score_11: data.day1_ns_11,
          score_12: data.day1_ns_12,
          score_13: data.day1_ns_13,
          score_14: data.day1_ns_14,
          score_15: data.day1_ns_15,
          score_16: data.day1_ns_16,
          score_17: data.day1_ns_17,
          score_18: data.day1_ns_18,
          net: data.day1_net,
          points_total: data.day1_net,
          hdc: '',
          in: data.day1_ns_in,
          out: data.day1_ns_out,
          isClickable: true,
        },
        net_points:{ 
          name: 'NET POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day1_np_1,
          score_2: data.day1_np_2,
          score_3: data.day1_np_3,
          score_4: data.day1_np_4,
          score_5: data.day1_np_5,
          score_6: data.day1_np_6,
          score_7: data.day1_np_7,
          score_8: data.day1_np_8,
          score_9: data.day1_np_9,
          score_10: data.day1_np_10,
          score_11: data.day1_np_11,
          score_12: data.day1_np_12,
          score_13: data.day1_np_13,
          score_14: data.day1_np_14,
          score_15: data.day1_np_15,
          score_16: data.day1_np_16,
          score_17: data.day1_np_17,
          score_18: data.day1_np_18,
          points: data.day1_net_points,
          points_total: data.day1_net_points,
          hdc: '',
          in: data.day1_np_in,
          out: data.day1_np_out,
          isClickable: true,
        }
      }))
      const player_score_two = data?.data?.map((data, index) => ({
               gross_scores:{ 
          name: 'GROSS SCORES',
          key: 3,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_gs_1,
          score_2: data.day2_gs_2,
          score_3: data.day2_gs_3,
          score_4: data.day2_gs_4,
          score_5: data.day2_gs_5,
          score_6: data.day2_gs_6,
          score_7: data.day2_gs_7,
          score_8: data.day2_gs_8,
          score_9: data.day2_gs_9,
          score_10: data.day2_gs_10,
          score_11: data.day2_gs_11,
          score_12: data.day2_gs_12,
          score_13: data.day2_gs_13,
          score_14: data.day2_gs_14,
          score_15: data.day2_gs_15,
          score_16: data.day2_gs_16,
          score_17: data.day2_gs_17,
          score_18: data.day2_gs_18,
          gross: data.day2_gross,
          hdc: data.hdc,
          in: data.day2_gs_in,
          out: data.day2_gs_out,
          day2_adj_hdc: data.day2_adj_hdc,
        },
        gross_points:{ 
          name: 'GROSS POINTS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_gp_1,
          score_2: data.day2_gp_2,
          score_3: data.day2_gp_3,
          score_4: data.day2_gp_4,
          score_5: data.day2_gp_5,
          score_6: data.day2_gp_6,
          score_7: data.day2_gp_7,
          score_8: data.day2_gp_8,
          score_9: data.day2_gp_9,
          score_10: data.day2_gp_10,
          score_11: data.day2_gp_11,
          score_12: data.day2_gp_12,
          score_13: data.day2_gp_13,
          score_14: data.day2_gp_14,
          score_15: data.day2_gp_15,
          score_16: data.day2_gp_16,
          score_17: data.day2_gp_17,
          score_18: data.day2_gp_18,
          gross: data.day2_gross_points,
          hdc: data.hdc,
          in: data.day2_gp_in,
          out: data.day2_gp_out,
          day2_adj_hdc: data.day2_adj_hdc,
        },
        net_scores:{ 
          name: 'NET SCORES',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_ns_1,
          score_2: data.day2_ns_2,
          score_3: data.day2_ns_3,
          score_4: data.day2_ns_4,
          score_5: data.day2_ns_5,
          score_6: data.day2_ns_6,
          score_7: data.day2_ns_7,
          score_8: data.day2_ns_8,
          score_9: data.day2_ns_9,
          score_10: data.day2_ns_10,
          score_11: data.day2_ns_11,
          score_12: data.day2_ns_12,
          score_13: data.day2_ns_13,
          score_14: data.day2_ns_14,
          score_15: data.day2_ns_15,
          score_16: data.day2_ns_16,
          score_17: data.day2_ns_17,
          score_18: data.day2_ns_18,
          net: data.day2_net,
          points_total: data.day2_net,
          hdc: '',
          in: data.day2_ns_in,
          out: data.day2_ns_out,
          isClickable: true,
        },
        net_points:{ 
          name: 'NET POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.day2_np_1,
          score_2: data.day2_np_2,
          score_3: data.day2_np_3,
          score_4: data.day2_np_4,
          score_5: data.day2_np_5,
          score_6: data.day2_np_6,
          score_7: data.day2_np_7,
          score_8: data.day2_np_8,
          score_9: data.day2_np_9,
          score_10: data.day2_np_10,
          score_11: data.day2_np_11,
          score_12: data.day2_np_12,
          score_13: data.day2_np_13,
          score_14: data.day2_np_14,
          score_15: data.day2_np_15,
          score_16: data.day2_np_16,
          score_17: data.day2_np_17,
          score_18: data.day2_np_18,
          points: data.day2_net_points,
          points_total: data.day2_net_points,
          hdc: '',
          in: data.day2_np_in,
          out: data.day2_np_out,
          isClickable: true,
        }
      }))
      const dayOneGs = player_score_one.map((player) => player.gross_scores);    
      const dayOneGp = player_score_one.map((player) => player.gross_points);    
      const dayOneNs = player_score_one.map((player) => player.net_scores);    
      const dayOneNp = player_score_one.map((player) => player.net_points);    

      const dayTwoGs = player_score_two.map((player) => player.gross_scores);    
      const dayTwoGp = player_score_two.map((player) => player.gross_points);    
      const dayTwoNs = player_score_two.map((player) => player.net_scores);    
      const dayTwoNp = player_score_two.map((player) => player.net_points);      

      setDayOneData(() => [
        ...dataHeader,
        ...dayOneGs,
        ...dayOneGp,
        ...dayOneNs,
        ...dayOneNp,
      ]);

      setDayTwoData(() => [
        ...dataHeader,
        ...dayTwoGs,
        ...dayTwoGp,
        ...dayTwoNs,
        ...dayTwoNp,
      ]);

    } else {
      setDayOneData([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Layout className='page'>
      <Navbar navKey={'invitational_nav'} />
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={15} className='header-container'>
            <Space>
              <ArrowBack className='cursor' onClick={() => navigate('/invitational/player/' + id)}/>
              SCORECARD
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24} className='px-4'>
            <Select 
              style={{width:'50%'}}
              size='large'
              placeholder="Select Team" 
              value={playerId}
              onChange={(e) => handlePlayerScore(e, playerData)}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {playerData?.map((option) => (
                  <Option key={option.player_id} value={option.player_id}>{option.name}</Option>
              ))}
            </Select>    
          </Col>
        </Row>
        <Row className="page-content">
          <Col span={24}>
            <Tabs 
              defaultActiveKey="all" 
              type="card" 
              activeKey={filterConfig?.status}
              className="custom-tabs"
              onChange={onChange}
            >
              <TabPane tab="Scores" key="day_one">
                {
                  dayOneData.length !== 0 && (
                    <div
                      className='mb-4'
                    >
                      <Table
                        components={components}
                        bordered
                        dataSource={[playerDivision]}
                        columns={headerColumns}
                        pagination={false}
                        showHeader={false}
                        rowClassName='div-table'
                      />
                    </div>
                  )
                }
                <Title level={3}>DAY 1</Title>
                <div 
                  className='mb-4'
                >
                  <EditableScoreCard 
                    dataSource={dayOneData} 
                    setDataSource={setDayOneData} 
                    columns={columns} 
                    loading={isLoading}
                  />
                </div>

                {/* {
                  dayTwoData.length !== 0 && (
                    <Table
                      components={components}
                      bordered
                      dataSource={[playerDivision]}
                      columns={headerColumns}
                      pagination={false}
                      showHeader={false}
                      rowClassName='div-table'
                    />
                  )
                } */}
                <Title level={3}>DAY 2</Title>
                <div
                  className='mb-4'
                >
                  <EditableScoreCard 
                    dataSource={dayTwoData} 
                    setDataSource={setDayTwoData} 
                    columns={columns} 
                    loading={isLoading}
                  />
               </div>

                {
                  playerId && (
                    <Row>
                      <Col span={18}></Col>
                      <Col align='right' span={6} className='py-4 px-2'>
                        <Button className='edit-btn' onClick={handleAddOk}>
                          Save
                        </Button>
                      </Col>
                    </Row>
                  )
                }
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default InvitationalScoreCard;